import React, { useEffect } from "react";
import { X } from "lucide-react";

/* Full-screen image viewer. `src` null = closed. Esc / backdrop click to close. */
export default function Lightbox({ src, alt = "", onClose, testid = "lightbox" }) {
    useEffect(() => {
        if (!src) return;
        const onKey = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
    }, [src, onClose]);
    if (!src) return null;
    return (
        <div data-testid={testid} role="dialog" aria-modal="true" onClick={onClose}
            className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-3 md:p-8">
            <button type="button" onClick={onClose} data-testid={`${testid}-close`} aria-label="Chiudi"
                className="absolute top-4 right-4 w-11 h-11 inline-flex items-center justify-center border border-abnormal-paper/40 text-abnormal-paper hover:border-abnormal-acid hover:text-abnormal-acid bg-black">
                <X size={18} />
            </button>
            <img src={src} alt={alt} onClick={(e) => e.stopPropagation()}
                className="max-h-full max-w-full w-auto h-auto object-contain border border-abnormal-paper/30" />
        </div>
    );
}
